export const htmlSelectors = {
  MODULE: 'YMK-module',
  MODULE_IFRAME: 'YMK-module-iframe'
};

export const vtoTypes = {
  MAKEUP: 'makeup',
  FOUNDATION: 'foundation',
  SKINCARE: 'skincare'
};

export const mediaTypes = {
  CAMERA: 'camera',
  MODEL: 'model',
  UPLOAD: 'upload'
};

export const eventTypes = {
  APPLY_FUN_STICKER: 'applyFunSticker',
  APPLY_MAKEUP_BY_LOOK: 'applyMakeupByLook',
  APPLY_MAKEUP_BY_PATTERN: 'applyMakeupByPattern',
  APPLY_MAKEUP_BY_PRODUCT_RECOMMENDATION: 'applyMakeupByProductRecommendation',
  APPLY_MAKEUP_BY_SKU_SET: 'applyMakeupBySkuSet',
  APPLY_MAKEUP_BY_SKU: 'applyMakeupBySku',
  AUTHORIZE: 'authorize',
  BACK_ICON_CLICKED: 'backIconClicked',
  CAMERA_CLOSED: 'cameraClosed',
  CAMERA_FAILED: 'cameraFailed',
  CAMERA_FLIP_CLICKED: 'cameraFlipClicked',
  CAMERA_FLIPPED: 'cameraFlipped',
  CAMERA_OPENED: 'cameraOpened',
  CHANGE_INTENSITY_SLIDER: 'changeIntensitySlider',
  CHANGE_INTENSITY: 'changeIntensity',
  CHANGE_ROUTE: 'changeRoute',
  CHOOSE_MODEL_ICON_CLICKED: 'chooseModelIconClicked',
  CLOSE_ENGINE: 'closeEngine',
  CLOSE: 'close',
  CLOSED: 'closed',
  COMPARE_DISABLED: 'compareDisabled',
  COMPARE_OFF: 'compareOff',
  COMPARE_RESET: 'compareReset',
  COMPARE: 'compare',
  DRAG_COMPARE_INDICATOR: 'dragCompareIndicator',
  ENGINE_CLOSED: 'engineClosed',
  EYEWEAR_PD_CHANGED: 'eyewearPDChanged',
  EYEWEAR_PD_SLIDER_ENABLED: 'eyewearPDSliderEnabled',
  FACE_ATTRIBUTE_PREDICTED: 'faceAttributePredicted',
  FACE_ATTRIBUTE_PREDICTION_TRIGGERED: 'faceAttributePredictionTriggered',
  FACE_ATTRIBUTE_PREDICTORS_INITIALIZED: 'faceAttributePredictorsInitialized',
  FACE_DETECTION: 'faceDetection',
  FACE_QUALITY_CHANGED: 'faceQualityChanged',
  FACE_QUALITY_CHECKER_CLOSED: 'faceQualityCheckerClosed',
  FACE_QUALITY_CHECKER_OPENED: 'faceQualityCheckerOpened',
  FUNCTION_TYPE_CHANGED: 'functionTypeChanged',
  INVALID_FILE_TYPE: 'invalidFileType',
  KISS_DETECTED: 'kissDetected',
  LAUNCHER_PAGE_ENTERED: 'launcherPageEntered',
  LIVE_CAM_ICON_CLICKED: 'liveCamIconClicked',
  LIVE_HAIR_DYE_APPLIED: 'liveHairDyeApplied',
  LOAD_ENGINE_COMPLETE: 'loadEngineComplete',
  LOAD_IMAGE_BY_CAPTURE: 'loadImageByCapture',
  LOAD_IMAGE_BY_MODEL: 'loadImageByModel',
  LOAD_IMAGE_BY_UPLOAD: 'loadImageByUpload',
  LOAD_IMAGE: 'loadImage',
  LOAD_VIDEO: 'loadVideo',
  LOADED: 'loaded',
  LOADING: 'loading',
  MAKEUP_EFFECT_APPLIED: 'makeupEffectApplied',
  MAKEUP_EFFECT_START_TO_APPLY: 'makeupEffectStartToApply',
  MODULE_SETTING_CHANGED: 'moduleSettingChanged',
  NEXT_FACE_DETECTION_PHASE: 'nextFaceDetectionPhase',
  NO_FACE_IN_PHOTO: 'noFaceInPhoto',
  OFFLINE_MODE_COMPLETE: 'offlineModeComplete',
  OFFLINE_MODE_EXPIRED: 'offlineModeExpired',
  OFFLINE_MODE_INIT: 'offlineModeInit',
  OFFLINE_MODE_NETWORK_ERROR: 'offlineModeNetworkError',
  OFFLINE_MODE_NOTREADY: 'offlineModeNotReady',
  OFFLINE_MODE_UNSUPPORTED: 'offlineModeUnsupported',
  OPEN_SEND_MAIL_4_WAY: 'openSendMail4Way',
  OPEN: 'open',
  OPENED: 'opened',
  PAUSE: 'pause',
  PHOTO_LOADED: 'photoLoaded',
  PRODUCT_RECOMMENDATION_FAILURE: 'productRecommendationFailure',
  PRODUCT_RECOMMENDATION_STARTED: 'productRecommendationStarted',
  PRODUCT_RECOMMENDATION_SUCCESS: 'productRecommendationSuccess',
  RECORD_COMPLETE: 'recordComplete',
  RECORD_STARTED: 'recordStarted',
  RESET: 'reset',
  RESIZE: 'resize',
  RESUME: 'resume',
  RETRIEVE_LANDMARKS: 'retrieveLandmakrs',
  SAVE_CANVAS_COMPLETE: 'saveCanvasComplete',
  SAVE_CANVAS: 'saveCanvas',
  SAVE_PHOTO_RESULT: 'savePhotoResult',
  SAVE_PHOTO: 'savePhoto',
  SAVE_SHAREPHOTO_COMPLETE: 'saveSharePhotoComplete',
  SAVE_SHAREPHOTO_RESULT: 'saveSharePhotoResult',
  SAVE_SHAREPHOTO: 'saveSharePhoto',
  SELECT_SAVE_PHOTO_MODEL: 'selectSavePhotoModel',
  SHADE_FINDER_CANCELLED: 'cancelShadeFinder',
  SHADE_FINDER_CLOSED: 'shadeFinderClosed',
  SHADE_FINDER_COMPLETE: 'shadeFinderComplete',
  SHADE_FINDER_OPENED: 'shadeFinderOpened',
  SHADE_FINDER_STARTED: 'shadeFinderStarted',
  SHADE_FINDER_UNDERTONE_CHANGED: 'shadeFinderUndertoneChanged',
  SHARE_TO_FB_CANCEL: 'shareToFBCancel',
  SHARE_TO_FB_SUCCESS: 'shareToFBSuccess',
  SHARE_TO_FB: 'shareToFB',
  SHARE_TO_PINTEREST: 'shareToPinterest',
  SHARE_TO_SMS: 'shareToSMS',
  SHARE_TO_WEIBO: 'shareToWeibo',
  SHARE_TO_WHATSAPP: 'shareToWhatsApp',
  SHARE_VIA_EMAIL_FAILURE: 'shareViaEmailFailure',
  SHARE_VIA_EMAIL_SUCCESS: 'shareViaEmailSuccess',
  SHARE_VIA_EMAIL: 'shareViaEmail',
  SKIN_ANALYSIS_CAPTURED: 'skinAnalysisCaptured',
  SKIN_ANALYSIS_CLOSED: 'skinAnalysisClosed',
  SKIN_ANALYSIS_COMPLETED: 'skinAnalysisCompleted',
  SKIN_ANALYSIS_FEATURE_UPDATED: 'skinAnalysisFeatureUpdated',
  SKIN_ANALYSIS_FINISHED: 'skinAnalysisFinished',
  SKIN_ANALYSIS_OPENED: 'skinAnalysisOpened',
  SKIN_ANALYSIS_PARAMETER_CHANGED: 'skinAnalysisParameterChanged',
  SKIN_ANALYSIS_PARAMETER_INPUT_CHANGED: 'skinAnalysisParameterInputChanged',
  SKIN_ANALYSIS_PROGRESS_UPDATED: 'skinAnalysisProgressUpdated',
  SKIN_ANALYSIS_STARTED: 'skinAnalysisStarted',
  SKIN_ANALYSIS_UPDATED: 'skinAnalysisUpdated',
  SKIN_SHADE_FOUND: 'skinShadeFound',
  SNAPSHOT: 'snapshot',
  SPLIT_FOUR_WAY_CHANGED: 'splitFourWayChanged',
  SPLIT_FOUR_WAY_DISABLED: 'splitFourWayDisabled',
  SPLIT_FOUR_WAY_OFF: 'splitFourWayOff',
  SPLIT_FOUR_WAY: 'splitFourWay',
  STICKER_EFFECT_APPLIED: 'stickerEffectApplied',
  TAKE_PHOTO: 'takePhoto',
  TOAST_MESSAGE: 'toastMessage',
  UNSUPPORTED_RESOLUTION: 'unsupportedResolution',
  UPLOAD_PHOTO_ICON_CLICKED: 'uploadPhotoIconClicked',
  VTO_ACTIONS_TRACKING: 'VTOActionsTracking',
  ZOOM: 'zoom'
};
